"use strict";
/**
 * 主题市场与主题订阅。
 *
 * 与 `billing.ts` 分开：那边是套餐（配额、升降档、停站），这边是**附加商品**。
 * 两者共用同一条支付通道与同一张订单表，但计费语义完全不同 ——
 * 主题不参与配额，也不影响站点是否可访问。
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=theme-market.js.map